import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";
import { SwissFlag } from "@/components/SwissFlag";

const Footer = forwardRef<HTMLElement>((_, ref) => (
  <footer ref={ref} className="border-t bg-card mt-auto">
    <div className="container py-14 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
        <div className="md:col-span-4 space-y-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-bold text-lg"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            <BrandLogo className="h-6 w-6 text-primary" />
            <span className="leading-none">
              <span className="text-primary">nLPD</span>
              <span>&nbsp;Conform</span>
            </span>
          </Link>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
            Outil suisse d'analyse de conformité à la nouvelle loi fédérale sur la protection des données.
            Indicatif, transparent, et conçu pour être actionnable.
          </p>
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-background px-3 py-1.5 text-xs font-medium text-foreground/80">
            <SwissFlag className="h-3.5 w-3.5 rounded-[2px]" />
            Édité depuis Genève
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-semibold mb-3 text-xs uppercase tracking-wider text-foreground/70">Produit</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/" className="hover:text-primary transition-colors">Analyse gratuite</Link></li>
            <li><Link to="/acheter-diagnostic-pro" className="hover:text-primary transition-colors">Dossier Pro nLPD</Link></li>
            <li><Link to="/audit-pro" className="hover:text-primary transition-colors">Mes diagnostics</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-semibold mb-3 text-xs uppercase tracking-wider text-foreground/70">Ressources</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/guide-nlpd" className="hover:text-primary transition-colors">Guide nLPD gratuit</Link></li>
            <li><Link to="/blog" className="hover:text-primary transition-colors">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
            <li><Link to="/a-propos" className="hover:text-primary transition-colors">À propos</Link></li>
            <li><Link to="/signaler-un-probleme" className="hover:text-primary transition-colors">Signaler un problème</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-semibold mb-3 text-xs uppercase tracking-wider text-foreground/70">Légal &amp; contact</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/mentions-legales" className="hover:text-primary transition-colors">Mentions légales</Link></li>
            <li><Link to="/politique-de-confidentialite" className="hover:text-primary transition-colors">Politique de confidentialité</Link></li>
          </ul>
          <address className="not-italic text-sm text-muted-foreground mt-4 space-y-0.5">
            <div className="text-foreground/80 font-medium">Jager Dori</div>
            <div>Rue Fendt 1</div>
            <div>1201 Genève, Suisse</div>
          </address>
        </div>
      </div>

      <div className="border-t mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} nLPD Conform · édité par Jager Dori. Tous droits réservés.</p>
        <p>
          <a
            href="https://jager-dori-lead-hub.lovable.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 hover:opacity-80 transition-opacity"
          >
            <span className="text-muted-foreground">Édité par</span>
            <span className="font-bold" style={{ color: "#00b8d9" }}>Jager</span>
            <span className="font-bold text-foreground">Dori</span>
          </a>
        </p>
      </div>
    </div>
  </footer>
));
Footer.displayName = 'Footer';

export default Footer;
